import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { authFeatureKey, AuthState } from './auth.reducer';

export const selectAuthState: MemoizedSelector<object, AuthState> =
    createFeatureSelector<AuthState>(authFeatureKey);

export const selectAuthToken = createSelector(selectAuthState, (state) => state.token);
